"use client";

import { useEffect, useRef } from "react";
import { useSession } from "next-auth/react";

import { setNetCookies } from "@/actions/set-net-cookies";

export function CookieSync() {
  const { data: session, status } = useSession();
  const hasSyncedRef = useRef(false);

  useEffect(() => {
    if (status !== "authenticated" || !session?.netData) return;

    // Only run once per session on the client to avoid route refresh animations
    const storageKey = `netCookiesSynced_${session.user?.id || "unknown"}`;
    const alreadySynced =
      typeof window !== "undefined" && window.localStorage.getItem(storageKey);

    if (hasSyncedRef.current || alreadySynced) return;

    hasSyncedRef.current = true;

    // Fire-and-forget; avoid any state changes that could cause re-renders
    Promise.resolve()
      .then(() => setNetCookies())
      .then((result) => {
        if (typeof window !== "undefined") {
          window.localStorage.setItem(storageKey, "true");
        }
        if (!result?.success) {
          // Keep logs minimal to avoid noisy devtools but helpful for diagnostics
          console.warn("CookieSync: setNetCookies failed", result?.error);
        } else {
          console.log("CookieSync: netData cookies synced successfully");
        }
      })
      .catch((err) => {
        console.warn("CookieSync: unexpected error", err);
      });
  }, [session, status]);

  return null; // This component doesn't render anything
}
